// extracted by mini-css-extract-plugin
module.exports = {"root":"Text_root__2yL2M","normal":"Text_normal__vPd9m","bold":"Text_bold__D7t0F","noMargin":"Text_noMargin__9dVG_","responsive":"Text_responsive__FJczT"};